// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"style-module--userProfile--3Pw4w","hoverBg":"style-module--hoverBg--HbXuo","authBtn":"style-module--authBtn--2axgG"};